import { APIKEYS } from '../constants/actionTypes';

const initial = { items: [], loading: false };

export default function apiKeysReducer(state = initial, action) {
  switch (action.type) {
    case APIKEYS.LIST_REQUEST: return { ...state, loading: true };
    case APIKEYS.LIST_SUCCESS: return { ...state, loading: false, items: action.payload };
    case APIKEYS.CREATE:       return { ...state, items: [action.payload, ...state.items] };
    case APIKEYS.REMOVE:       return { ...state, items: state.items.filter(t => t._id !== action.payload) };
    default: return state;
  }
}
